export default "/images/e2ebf7f0f4be51800ee959f7146ba7cd.avif";